import shuffle from "shuffle-array";
import { forceUpdate } from "..";
export class Deck {
    constructor(position) {
        this.position = position;
        const type = this.constructor;
        this.cards = shuffle(type.initialCards, { copy: true }).map((CardClass) => new CardClass(this.position));
        this.discard = [];
        this.id = "deck" + Deck._nextId++;
        this.cardAddQueue = type.initialCardAddQueue;
        this.cardsAllowed = type.initialCardsAllowed;
    }
    addNextCard() {
        const filter = (cardType) => this.cardsAllowed.has(cardType);
        let cardType = this.cardAddQueue.find(filter);
        let cardIndex = this.cardAddQueue.findIndex(filter);
        if (!cardType) {
            cardType = Array.from(this.cardsAllowed).pop();
        }
        this.addCard(cardType);
        this.cardAddQueue.splice(cardIndex, 1);
    }
    addCard(cardType) {
        this.cards.push(new cardType(this.position));
        forceUpdate();
    }
}
Deck._nextId = 0;
export function getClassFromDeck(foo) {
    return foo.constructor;
}
